<script>
  /**
   * 半角数字とハイフンのみの入力欄
   */
  import TextInput from './TextInput.svelte'

  export let id = undefined
  export let name
  export let label = ''
  export let value = undefined
</script>

<TextInput
  id={`${id || name}-PhoneInput`}
  {name}
  type="text"
  {label}
  inputAttributes={{ inputmode: 'numeric', pattern: '(\\d|-)*' }}
  bind:value
/>
